// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"475":"aa132297","548":"7d8f3a25","856":"5049d2f9"}[chunkId] + ".chunk.js";
};